/*  ========================================================================
    # Scripts - Text with Media Shortcode
    ========================================================================  */

/**
 * Moves [schreyer_media_label] shortcode placeholders into the
 * .s-text-with-media__image-wrapper of their parent section.
 */
const TextWithMediaShortcode = {
  init() {
    document.querySelectorAll('.s-text-with-media__schreyer-label-placeholder').forEach(placeholder => {
      const section = placeholder.closest('.s-text-with-media');
      if (!section) return;

      const variant = section.dataset.variant;
      if (variant !== '5.0' && variant !== '5.1') return;

      const wrapper = section.querySelector('.s-text-with-media__image-wrapper');
      if (!wrapper) return;

      const p = document.createElement('p');
      p.textContent = placeholder.dataset.text;

      const label = document.createElement('div');
      label.className = 's-text-with-media__schreyer-label';
      label.appendChild(p);
      wrapper.appendChild(label);
      placeholder.remove();
    });
  }
};

export default TextWithMediaShortcode;
